/*global window._appConstants */
import React, { useRef, useState } from "react";
import IdleTimer from "react-idle-timer";
import TokenStorage from "./js/utils/tokenStorage";
import { useDispatch } from "react-redux";
import { Button } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import WarningIcon from "@material-ui/icons/Warning";
import HighlightOffOutlinedIcon from "@material-ui/icons/HighlightOffOutlined";
import { UserProfile as UserProfileActions } from "./js/actions";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: "15px !important",
    boxShadow: "0 1px 4px rgba(0,0,0,0.06), 0 4px 20px rgba(0,0,0,0.05) !important",
  },
  dialogRoot: {
    zIndex: "1400 !important",
  },
  dialogHeader: {
    padding: "14px 20px",
    borderBottom: "1px solid #f1f5f9",
    display: "flex",
    alignItems: "center",
    gap: 10,
    backgroundColor: "#FFF7ED",
  },
  dialogHeaderIconBox: {
    width: 40,
    height: 40,
    borderRadius: 12,
    backgroundColor: "#ffedd5",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  dialogHeaderIcon: {
    fontSize: "20px !important",
    color: "#ea580c",
  },
  dialogHeaderTitle: {
    fontWeight: 700,
    fontSize: "16px !important",
    color: "#9a3412",
    textTransform: "uppercase",
    letterSpacing: 0.2,
  },
  dialogBody: {
    padding: "18px 20px",
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },
  dialogContentMain: {
    fontWeight: 500,
    fontSize: "14px !important",
    color: "#0f172a",
    lineHeight: 1.6,
  },
  dialogContentSub: {
    fontWeight: 400,
    fontSize: "12px !important",
    color: "#64748b",
    lineHeight: 1.5,
  },
  dialogFooter: {
    padding: "12px 20px",
    borderTop: "1px solid #e2e8f0",
    gap: 10,
  },
  dialogBtnOutlined: {
    borderRadius: 8,
    fontWeight: 600,
    color: "#0f172a",
    borderColor: "#e2e8f0",
    textTransform: "none",
    padding: "8px 20px",
    fontSize: "13px !important",
  },
  dialogBtnConfirm: {
    borderRadius: 8,
    fontWeight: 600,
    background: "linear-gradient(135deg, #ea580c 0%, #c2410c 100%)",
    textTransform: "none",
    padding: "8px 20px",
    fontSize: "13px !important",
    boxShadow: "0 2px 8px rgba(234, 88, 12, 0.35)",
  },
  exitIcon: {
    fontSize: "16px !important",
    marginRight: "6px",
  },
}));

const AuthLayout = (props) => {
  const { history } = props;
  const classes = useStyles();

  const dispatch = useDispatch();
  const idleTimerRef = useRef(null);
  const [openIdleDialog, setopenIdleDialog] = useState(false);
  const onIdle = () => {
    TokenStorage.getToken() ? logout() : console.log("Not Logged");
  };

  const closeDialogBox = () => {
    setopenIdleDialog(false);
  };

  const logout = () => {
    dispatch(UserProfileActions.clearLoginUserData()).then(function () {
      history.push(window._appConstants.useCommonDefaults.navRef.login);
    });
    setopenIdleDialog(true);
  };
  return (
    <div>
      <Dialog
        open={openIdleDialog}
        keepMounted
        maxWidth="sm"
        fullWidth
        classes={{ root: classes.dialogRoot, paper: classes.dialogPaper }}
      >
        <Box className={classes.dialogHeader}>
          <Box className={classes.dialogHeaderIconBox}>
            <WarningIcon className={classes.dialogHeaderIcon} />
          </Box>
          <Typography className={classes.dialogHeaderTitle}>
            Session Expired
          </Typography>
        </Box>

        <DialogContent className={classes.dialogBody}>
          <Typography className={classes.dialogContentMain}>
            You have been inactive for more than 60 minutes and have been logged out.
          </Typography>
          <Typography className={classes.dialogContentSub}>
            Please login again to continue using the application.
          </Typography>
        </DialogContent>

        <DialogActions className={classes.dialogFooter}>
          <Button
            onClick={closeDialogBox}
            variant="contained"
            className={classes.dialogBtnConfirm}
          >
            <ExitToAppIcon className={classes.exitIcon} />
            Login Again
          </Button>
        </DialogActions>
      </Dialog>
      <IdleTimer ref={idleTimerRef} timeout={60 * 60 * 1000} onIdle={onIdle} />
    </div>
  );
};

export default AuthLayout;
